import React from 'react';
import { getCouponPageConfig } from '../campaignStreamline/CreateCampaignCouponPageConfig';

export const COUPON_PAGE_CONFIG = getCouponPageConfig({
  fieldPrefix: "",
  isCampaign: false,
});
